import { render, staticRenderFns } from "./CompanyTreeSubtree.vue?vue&type=template&id=6b83e802"
import script from "./CompanyTreeSubtree.js?vue&type=script&lang=js&external"
export * from "./CompanyTreeSubtree.js?vue&type=script&lang=js&external"
import style0 from "./CompanyTreeSubtree.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports